import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tooltip from 'components/design-system/Tooltip'
import menuItem from 'menu-items'
import BorderLogo from 'components/design-system/BorderLogo'
import NavItem from 'components/design-system/NavItem'
import LicenseDialog from 'components/LicenseDialog'
import ProfilePopover from './ProfilePopover'
import NotificationPopover from './NotificationPopover'
import config from 'config'

const isMenuItemActive = (item, pathname) => {
  if (item.external) {
    return pathname.startsWith('/point-tasking')
  }
  if (!item.url) {
    return false
  }
  return pathname === item.url || pathname.startsWith(`${item.url}/`) || item.activeUrls?.some((url) => pathname.startsWith(url))
}

/** Nhóm nav (Figma nav-top / nav-bottom): nền bg/overlay, radius md, padding 4. */
const navGroupSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexShrink: 0,
  gap: 'var(--space-4)',
  p: 'var(--space-4)',
  bgcolor: 'var(--color-bg-overlay)',
  borderRadius: 'var(--radius-md)'
}

/** App Sidebar (Figma 8:9989). */
const Sidebar = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [licenseDialogOpen, setLicenseDialogOpen] = useState(false)

  const handleItemActivate = (item) => {
    if (item.external) {
      window.open(item.url, '_blank', 'noopener,noreferrer')
      return
    }
    navigate(item.url)
  }

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: 0,
        width: 56,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--space-24)',
        px: 'var(--space-8)',
        py: 'var(--space-16)',
        bgcolor: 'var(--color-bg-app)',
        borderRight: 'var(--stroke-default) solid var(--color-border-subtle)'
      }}
    >
      <BorderLogo width={40} />

      <Box sx={navGroupSx}>
        {menuItem.map((item) => (
          <Tooltip title={item.title} key={item.id} placement="right">
            <NavItem
              icon={item.icon}
              active={isMenuItemActive(item, pathname)}
              aria-label={item.title}
              onClick={() => handleItemActivate(item)}
            />
          </Tooltip>
        ))}
      </Box>

      <Box sx={{ flex: '1 0 0', minHeight: 0 }} />

      <Box sx={navGroupSx}>
        <Tooltip title="Home" placement="right">
          <NavItem icon="home" component="a" type={undefined} href={config.homeDashboardUrl} aria-label="Back to NBSS dashboard" />
        </Tooltip>
        <NotificationPopover />
        <ProfilePopover />
        <Tooltip title="Licenses" placement="right">
          <NavItem icon="license" aria-label="Licenses" onClick={() => setLicenseDialogOpen(true)} />
        </Tooltip>
      </Box>

      <LicenseDialog open={licenseDialogOpen} onClose={() => setLicenseDialogOpen(false)} />
    </Box>
  )
}

export default Sidebar
